export default __webpack_public_path__ + "static/media/img-boxes@2x.eca90291.jpg";